import { ART_EVENT_ENDPOINTS } from '../../constants/artEvent/endpoints';
import { CreateArtEventRequest } from '../../interfaces/artEvent/ArtEventInterfaces';

const { ART_EVENTS } = ART_EVENT_ENDPOINTS;

export const getArtEvents = (api: any) => {
  return api.get(ART_EVENTS);
};

export const createArtEvent = (
  api: any,
  artEventData: CreateArtEventRequest
) => {
  return api.post(ART_EVENTS, artEventData);
};
